export default __webpack_public_path__ + "static/media/fav-gray.0e62823c.webp";